import React, { Component } from 'react';
import i18n from '../../utils/translate';
import { animateScroll } from 'react-scroll';

import './styles.scss';

class PaymentError extends Component {
  componentDidMount() {
    sessionStorage.clear();
    animateScroll.scrollToTop({ duration: 0 });
  }

  render() {
    return (
      <div>
        <div className="error-box">
          <div className="error-msg-wrapper">
            <div>{i18n('Ihr Online-Abschluss war nicht erfolgreich.')}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default PaymentError;
